<template>
  <div style="height: 911px;">
    <div class="messageList">{{ $t('meg.messageList') }}</div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width=".85rem">
      <el-form-item :label="$t('meg.status')" prop="noticeRead">
        <el-select v-model="queryParams.noticeRead" class="m-2" placeholder="请选择" clearable>
          <el-option v-for="item in noticeReadOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">{{ $t('meg.search') }}</el-button>
        <el-button @click="resetQuery">{{ $t('meg.reset') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="messageBox" v-for="(item, index) in messageData" :key="index">
      <div style="display: flex; flex-direction: column;margin-top: 27px;text-align: left;">
        <div style="display: flex;">
          <span style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #333333;">{{
      item.noticeTitle }}</span>
          <span
            style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #333333;margin-left: .25rem;"
            v-if="item.noticeRead == 1">{{ $t('meg.read') }}</span>
          <span
            style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: red;margin-left: .25rem;"
            v-if="item.noticeRead == 0">{{ $t('meg.unread') }}</span>
        </div>
        <span
          style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #333333;margin-top: 11px">{{
      item.noticeContent }}</span>
      </div>
     <div style="display: flex;flex-direction: column;">
      <div
        style="margin-top: 31px;font-size: 14px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #A2A2A2;">
        {{ item.createTime }}</div>
        <el-button style="margin-top: .125rem" @click="readed(item)" v-if="item.noticeRead == 0">{{ $t('meg.markRead') }}</el-button>
     </div>
    </div>
    <div style="display: flex;justify-content: center;margin-bottom: .25rem;margin-top: .25rem">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryForm.pageSize"
        :current-page="queryForm.pageNum" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script setup>
import { messageList,updRecordData } from "@/api/person.js"
import { onMounted, reactive, ref } from "vue";
import { getDicts } from "@/api/order.js"
import { ElMessage } from 'element-plus'

const noticeReadOptions = ref([])
onMounted(() => {
  getList()
  getDicts("notice_read").then(response => {
    noticeReadOptions.value = response.data.data
  })
})
const total = ref(0)
const queryForm = reactive({
  pageSize: 10,
  pageNum: 1
})

const queryParams = reactive({
  pageNum: 1,
  pageSize: 10,
  noticeWay: null,
  noticeRead: '0',
  msgdelStatus: '0',
})
const messageData = ref([])


const readed = (rows) => {
  let obj = {
    mrId:rows.mrId,
    noticeRead:'1',
    noticeType:rows.noticeType
  }
  updRecordData(obj).then(res => {
    if(res.data.code == 200) {
      ElMessage.success("操作成功")
      getList()
    }
  })
}

const getList = () => {
  messageList(queryParams).then(res => {
    messageData.value = res.data.rows
    total.value = res.data.total
  })
}

const handleCurrentChange  = (val) => {
  queryForm.pageNum = val
  getList()
}

const handleQuery = () => {
  getList();
}
const resetQuery = () => {
  queryParams.noticeRead = null;
  queryParams.pageNum = 1;
  handleQuery();
}
</script>

<style scoped>
.messageList {
  height: 51px;
  background: #EEEEEE;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin: 29px 24px 0 31px;
  font-size: 16px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 700;
  color: #000000;
  line-height: 51px;
  text-align: left;
  padding-left: 20px;
}

.messageBox {
  height: 106px;
  border-bottom: 1px solid #DDDDDD;
  margin-left: 33px;
  margin-right: 24px;
  display: flex;
  justify-content: space-between;
}

::v-deep .el-input {
  width: 2.6875rem !important;
  height: .45rem !important;
}

::v-deep .el-form-item__label {
  line-height: .45rem !important;
}
</style>
